import { render, staticRenderFns } from "./OutputFields.vue?vue&type=template&id=13f92270&scoped=true&"
import script from "./OutputFields.vue?vue&type=script&lang=js&"
export * from "./OutputFields.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=13f92270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f92270",
  null
  
)

export default component.exports